import { render, staticRenderFns } from "./landFilterCom.vue?vue&type=template&id=13dd0fbe&scoped=true"
import script from "./landFilterCom.vue?vue&type=script&lang=js"
export * from "./landFilterCom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dd0fbe",
  null
  
)

export default component.exports